import DebugUserSwitcher from 'gcs-common/components/DebugUserSwitcher/DebugUserSwitcher';
// import MaintenanceScreen from 'gcs-common/components/MaintenanceScreen/MaintenanceScreen';
import useShowErrorDialogFromSearchParams from 'gcs-common/hooks/useShowErrorDialogFromSearchParams';
import useTheme from 'gcs-common/hooks/useTheme';
import useTrackLocationChange from 'gcs-common/hooks/useTrackLocationChange';
import useUsercentrics from 'gcs-common/hooks/useUsercentrics';
import { resetMembersTyping } from 'gcs-common/slices/members/membersSlice';
import { getUsercentricsId } from 'gcs-common/slices/theme/themeSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import styles from './styles.module.scss';
import 'react-toastify/dist/ReactToastify.css';
import { useQueryClient } from '@tanstack/react-query';
import {
  CurrentUserQueryKeys,
  type CurrentUserResponseData,
} from 'gcs-common/clients/api/entities/current-user/current-user-api';
import { currentUserUpdated } from 'gcs-common/slices/currentUser/currentUserSlice';
import moment from 'moment';
import { useEffect } from 'react';
import ChangeTheme from '../ChangeTheme/ChangeTheme';
import EditImageModal from '../EditImageModal/EditImageModal';
import ErrorDialog from '../ErrorDialog/ErrorDialog';
import MetaTags from '../MetaTags/MetaTags';
import WebcamModal from '../WebcamModal/WebcamModal';
// @ts-expect-error not types available for this package
import 'moment/dist/locale/de';

const App = () => {
  const usercentricsId = useSelector(getUsercentricsId);
  useUsercentrics(usercentricsId);
  useTrackLocationChange();
  useTheme();
  useShowErrorDialogFromSearchParams();
  moment.locale('de');

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  // Reset all members to not typing if app is closed while typing
  // and the Timeout got cleared.
  useEffect(() => {
    dispatch(resetMembersTyping());
  }, []);

  // sync react query store with redux store (temporary solution until redux is removed)
  useEffect(() => {
    const userData = queryClient.getQueryData<CurrentUserResponseData>([CurrentUserQueryKeys.GET_CURRENT_USER]);
    if (userData) {
      dispatch(currentUserUpdated({ user: userData }));
    }
  }, []);

  return (
    <div className={styles.root}>
      <ChangeTheme />
      <DebugUserSwitcher />
      <MetaTags />
      <ToastContainer icon={false} theme="colored" autoClose={false} className={styles.toastContainer} />
      {/* <MaintenanceScreen /> */}
      <Outlet />
      <ErrorDialog />
      <EditImageModal />
      <WebcamModal />
    </div>
  );
};

export default App;
